<template>
    <div id="mailType1">
        <div class=startingEndPoint>
            <StartingEndPoint :startSlipmentList="slipmentList" :endSlipmentList="slipmentList" :curSlipment="curSlipment"/>
        </div>
        <BoxList/>
        <div class="letterNum">
            <div class="h">
                <span>信封數量</span>
            </div>
            <div class="b">
                <Count :kg="0.5" :callback="incrementNumAndDecrementNum" :count="this.$store.getters.totalParts"/>
                <div class="tips">
                    單位尺寸 32 厘米 x 25 厘米 x 1 厘米 每件重量 0.5 公斤
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StartingEndPoint from "@/components/StartingEndPoint"
import BoxList from "@/views/Mail/BoxList/BoxList"
import Count from '@/components/Count.vue'
import {mapState,mapActions} from 'vuex'
import {nanoid} from "nanoid"
export default {
    mame:'Type1',
    components:{
        StartingEndPoint,
        Count,
        BoxList
    },
    data() {
        return {
            // 发货地选项
            slipmentList:[
            ],
            // 当前选择的发货国家
            curSlipment:'香港',
            // 物品尺寸表单
            "orderBoxes":{
                "boxType":"01",
                "id":'letternum or id',
                "boxid": 0,
                // 数量
                "count": this.$store.getters.totalParts,
                // 高
                "highBox": "1",
                // 长
                "longBox": "32",
                "orderId": 0,
                // 体积重量
                "volume": "0.5",
                // 宽
                "widthBox": "25"
            }
        }
    },
    methods: {
       ...mapActions(["decrementLetterNum","incrementLetterNum","editBox"]),
        // 用户点击添加数量
        incrementNumAndDecrementNum(type){
            if(this.boxInit){
                this.$store.commit("ADDORDERBOX",this.orderBoxes)
            }
            // 判断用户点击的是加还是减
            if(type){
                if( this.orderBoxes.count>=99) return
                this.editBox({
                    id:this.orderBoxes.id,
                    type:"increment"
                })
            }else{
                if(this.orderBoxes.count<=1) return
                this.editBox({
                    id:this.orderBoxes.id,
                    type:"decrement"
                })

            }
        }
    },
    computed:{  

        // boxInit为false代表vuex的orderBoxes数组上有信件箱子，否则则没有
        boxInit(){
            let valid = true
            // 如果箱子列表里有信件,就代表不是初始化信件
            this.$store.state.orderVo.orderBoxes.forEach(item => {
                if(item.boxType == "01") return valid = false
            })

            // 如果用户删除了信件,就让数量为0
            if(valid) this.orderBoxes.count = 0
            return valid
        }
    },
    mounted() {
        // 更新信件数量
        this.count = this.$store.state.letterNum
    },
}
</script>

<style lang="less" scoped>
    .letterNum{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-top: 60px;
        .h{
            width: 100%;
            margin-bottom: 20px;
            span{
                font-size: 17px;
            }
        }
        .b{
            display: flex;
            align-items: center;
           .count{
            display: flex;
            align-items: center;
            margin-right: 70px;
            .show{
                width: 150px;
                height: 65px;
                text-align: center;
                line-height: 65px;
                border: 1px solid #B5B5B5;
                border-radius: 20px;
                margin:0 5px;
                .numTips{
                    color: #B5B5B5;
                    font-size:17px;
                }
                .num{
                    font-size: 18px;
                }
            }
                .increment{
                    color:@colorMain;
                    font-size:30px;
                    &:hover{
                        cursor: pointer;
                    }
                }
                .decrement{
                    font-size:30px;
                    color: #868686;
                    &:hover{
                        cursor: pointer;
                    }
                }
        }
            .tips{
                width: 290px;
                font-family: PingFang HK;
                line-height: 30px;
                font-size: 17px;
            }
    }
}
/* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>